import { styled, Theme } from '@material-ui/core';
import React, { FC } from 'react';
import { Archive } from 'src/config/api/models/Archive';

type ArchiveListProps = {
  archivedBooks?: Archive[];
};

const StyledBookList = styled('ul')<Theme>(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: theme.spacing(2, 0),
  '& a': {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  '& li': {
    marginBottom: theme.spacing(1),
  },
}));

const ArchiveList: FC<ArchiveListProps> = ({ archivedBooks }) => {
  return (
    <StyledBookList>
      {archivedBooks &&
        archivedBooks.map((archive: Archive) => (
          <li key={archive.schoolYear}>
            <a href={`${archive.url}?token=${archive.token}`} target="_blank" rel="noopener noreferrer">
              Archief schooljaar {archive.schoolYear}
            </a>
          </li>
        ))}
    </StyledBookList>
  );
};

export default ArchiveList;
